import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Stack,
  Table,
  Breadcrumb,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
import { useLocation } from "react-router-dom";
import Main from "../layout/Main";
import solisPowerApi from "../../api/solisPowerApi";

import { Link } from "react-router-dom";
import { BrowserView } from "react-device-detect";
import InfoPill from "../InfoPill";
import { ROUTES } from "../../constants/webRouting";
import PERMISSIONS from "../../constants/permissions";
import { getUserDetails } from "../../utils/helper";
// Added by Jaseem 11-2-2026
import { DataGrid } from "@mui/x-data-grid";
import TextField from "@mui/material/TextField";
//=====================================================
const UserList = () => {
  const userInfo = getUserDetails();
  // const location = useLocation();
  const navigate = useNavigate();
  const [body, setBody] = useState([]);

  // Added By Jaseem 11-02-2026
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState(rows);
  const [searchText, setSearchText] = useState("");
  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = rows.filter((row) =>
      Object.values(row).some(
        (field) =>
          field && field.toString().toLowerCase().includes(value.toLowerCase()),
      ),
    );
    setFilteredRows(filtered);
  };
  async function init() {
    const result = await solisPowerApi.fetchUsersForListPage();
    console.log("result ==>", result);
    if (result) {
      setBody(result);
      const mappedRows = result.map((item, index) => ({
        id: item.id || index, // DataGrid ke liye mandatory
        username: item.username || "-",
        createddate: item.createddate || "-",
        userrole: item.userrole || "-",
        role_name: item.role_name || "-",
        user_type: item.user_type || "-",

        phone: item.phone || "-",
        email: item.email || "-",
        managername: item.managername || "-",
        isactive: item.isactive || "-",
      }));

      setRows(mappedRows);
      setFilteredRows(mappedRows);
    } else {
      setBody([]);
    }
  }
  useEffect(() => {
    init();
  }, []);
  // ==========================================================
  const editUser = (row) => {
    //console.log("row", row);
    navigate(`/users/${row.row.id}/e`, { state: row.row });
  };

  // Added By Jaseem 11-02-2026
  const columns = [
    {
      field: "username",
      headerName: "Name",
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const row = params.row;
        return (
          <Link
            to={"/users/" + row.id}
            state={row}
            style={{
              color: "#1a73e8",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            {row.username}
          </Link>
        );
      },
    },
    {
      field: "userrole",
      headerName: "User Type",
      flex: 1,
      sortable: true,
      renderCell: (params) => getUserRoleDisplayName(params.row.userrole),
    },
    {
      field: "role_name",
      headerName: "User Role",
      flex: 1,
      sortable: true,
    },
    {
      field: "user_type",
      headerName: "User Category",
      flex: 1,
      sortable: true,
    },
    {
      field: "phone",
      headerName: "Phone",
      flex: 1,
      sortable: true,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      sortable: true,
    },
    {
      field: "managername",
      headerName: "Manager",
      flex: 1,
      sortable: true,
      // renderCell: (params) => {
      //   const row = params.row;
      //   return row?.managername ? (
      //     <Link
      //       to={`${ROUTES.USER.LIST}/${row.managerid}`}
      //       state={row}
      //       style={{ color: "#1a73e8", textDecoration: "none" }}
      //     >
      //       {row.managername}
      //     </Link>
      //   ) : (
      //     "-"
      //   );
      // },
    },
    {
      field: "isactive",
      headerName: "Active",
      flex: 0.6,
      sortable: true,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const val = params.row.isactive;
        return val ? (
          <i
            className="fa-regular fa-square-check"
            style={{ fontSize: "1.3rem" }}
          />
        ) : (
          <i className="fa-regular fa-square" style={{ fontSize: "1.3rem" }} />
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.7,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const row = params.row;

        const canEdit = [PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_USER].some(
          (permission) =>
            userInfo?.permissions.map((p) => p.name).includes(permission),
        );

        return (
          canEdit && (
            <Button
              size="sm"
              className="btn-custom"
              onClick={() => editUser({ row })}
            >
              <i className="fa-regular fa-pen-to-square"></i>
            </Button>
          )
        );
      },
    },
  ];
  //==================================================================

  const getUserRoleDisplayName = (role) => {
    switch (role) {
      // case "SUPER_ADMIN":
      //   return "SUPER ADMIN";
      // case "ADMIN":
      //   return "Office User";
      // case "USER":
      //   return "Factory User";
      default:
        return role;
    }
  };

  const createUser = () => {
    navigate(`/users/e`);
  };

  return (
    <Container fluid>
      <Row className="align-items-end ">
        <Col lg={12} className="">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.USER.LIST)}>
              Users
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        {/* Added By Jaseem 11-02-2026 */}
        <Col lg={2} md={4} xl={2} sm={12} className="">
          <div className="leads-header">
            <div className="leads-actions">
              <TextField
                size="small"
                placeholder="Search leads..."
                className="custom-search-field"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>
        </Col>
        {/* =================================================== */}

        <Col className="py-1">
          {/* <BrowserView> */}
          <div className="d-flex py-1 px-2 ">
            <InfoPill
              left="Total"
              right={body?.length}
              rightClasses="bg-custom text-white border-white fw-bold"
              leftClasses="bg-white  fw-bold "
            />
          </div>
          {/* </BrowserView> */}
        </Col>
        <Col
          xs={12}
          sm={6}
          lg={4}
          className="d-flex flex-col justify-content-end align-items-end"
        >
          <Stack direction="horizontal" gap={2}>
            {[PERMISSIONS.MODIFY_ALL].some((permission) => {
              return userInfo?.permissions
                .map((p) => p.name)
                .includes(permission);
            }) && (
                <Button
                  size="sm"
                  className="btn-create"
                  onClick={() => createUser(true)}
                >
                  New User
                </Button>
              )}
          </Stack>
        </Col>
      </Row>
      {/* Added By Jaseem 11-02-2026 */}
      <Row>
        <div className="leads-page">
          {/* Header */}

          {/* DataGrid */}
          <div
            style={{
              height: 400,
              width: "100%",
              marginTop: "20px",
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            }}
          >
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={25}
              rowsPerPageOptions={[25]}
              getRowHeight={() => "auto"}
              disableRowSelectionOnClick
              className="custom-datagrid"
            />
          </div>
        </div>
      </Row>
      {/* ==========================End By Jaseem ============================================= */}
    </Container>
  );
};
export default UserList;
